import { gql } from '@apollo/client';
import { LanguageFragment } from '../fragments/LanguageFragment';
/**
 * @const LanguagesQuery
 * @since 1.0.0
 */
export const LanguagesQuery = gql `
  query LanguagesQuery {
    languages {
      ...LanguageFragment
    }
  }

  ${LanguageFragment}
`;
